
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createSiteLetterTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteLetterTemplateInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SiteLetterTemplateInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSiteLetterTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"siteLetterTemplateInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteLetterTemplateInput"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signature_file_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"company_logo_file_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"greeting"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"body_text_page_1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"body_text_page_2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sign_off"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"signature_page"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contact_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contact_email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contact_phone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"satellite_image_enabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"has_footer"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vat_registration_number"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"company_registration_number"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sender_address_line_1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sender_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sender_post_code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sender_city"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sender_province"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":563}};
    doc.loc.source = {"body":"mutation createSiteLetterTemplate($siteLetterTemplateInput: SiteLetterTemplateInput!) {\n  createSiteLetterTemplate(siteLetterTemplateInput: $siteLetterTemplateInput) {\n    signature_file_id\n    company_logo_file_id\n    greeting\n    body_text_page_1\n    body_text_page_2\n    sign_off\n    signature_page\n    contact_name\n    contact_email\n    contact_phone\n    satellite_image_enabled\n    has_footer\n    vat_registration_number\n    company_registration_number\n    sender_address_line_1\n    sender_name\n    sender_post_code\n    sender_city\n    sender_province\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["createSiteLetterTemplate"] = oneQuery(doc, "createSiteLetterTemplate");
        
